import {NotificationType, TriggerTargeting} from 'common/types/reports/messages';

import {LocalStorageKey} from '../constants';
import {getReportUrl} from './index';

interface SendToNotificationsBuilderArgs {
  projectId: number;
  messageType: NotificationType;
  targetingProps: TriggerTargeting;
  openInNewTab?: boolean;
  workspaceId?: number;
}

export function sendToNotificationsBuilder({
  projectId,
  messageType,
  targetingProps,
  openInNewTab = false,
  workspaceId = null,
}: SendToNotificationsBuilderArgs): void {
  // Universal cohort builder expects these keys to be JSON stringified.
  const keysToStringify = new Set([`cohort_selector`, `cohort_behaviors`]);
  const preparedTargetingProps = {};
  for (const [key, value] of Object.entries(targetingProps)) {
    preparedTargetingProps[key] = keysToStringify.has(key) ? JSON.stringify(value) : value;
  }

  localStorage.setItem(LocalStorageKey.MessageTargetingFromExplore, JSON.stringify(preparedTargetingProps));
  const builderUrl = `${getReportUrl(`triggers/messages`, {
    projectId,
    workspaceId,
  })}#builder/${messageType}/targeted/?step=1`;
  if (openInNewTab) {
    window.open(builderUrl, `_blank`);
  } else {
    window.open(builderUrl, `_self`);
  }
}
